// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg: #0b1020;
  --panel: #121a35;
  --panel-2: #0f1730;
  --border: #223059;
  --text: #e6e9f5;
  --muted: #a9b3cf;
  --primary: #5b8cff;
  --primary-600: #4779ff;
  --accent: #22d3ee;
  --success: #10b981;
  --warning: #f59e0b;
  --danger: #ef4444;
  --shadow: 0 10px 30px rgba(2, 6, 23, 0.5);
  --radius: 12px;
}

.App {
  min-height: 100vh;
  background: radial-gradient(1200px 600px at 20% -10%, rgba(34, 211, 238, 0.12), transparent),
    radial-gradient(1000px 500px at 120% 10%, rgba(91, 140, 255, 0.15), transparent),
    var(--bg);
  color: var(--text);
}

.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.topbar {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: linear-gradient(180deg, rgba(18, 26, 53, 0.85), rgba(18, 26, 53, 0.6));
  backdrop-filter: blur(6px);
  border-bottom: 1px solid var(--border);
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.brand-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--accent), var(--primary));
  box-shadow: 0 0 12px rgba(34, 211, 238, 0.6);
}

.topbar h1 {
  font-size: 18px;
  margin: 0;
  font-weight: 600;
  letter-spacing: 0.2px;
}

.status-badge {
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
  border: 1px solid var(--border);
  background: var(--panel);
  color: var(--muted);
}

.status-badge.active {
  color: #d1fae5;
  border-color: rgba(16, 185, 129, 0.3);
  background: linear-gradient(180deg, rgba(16, 185, 129, 0.15), rgba(16, 185, 129, 0.05));
}

.content {
  max-width: 1100px;
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.controls {
  display: flex;
  gap: 12px;
}

.button {
  appearance: none;
  border: 1px solid var(--border);
  background: linear-gradient(180deg, rgba(18, 26, 53, 0.9), rgba(18, 26, 53, 0.7));
  color: var(--text);
  padding: 10px 14px;
  border-radius: 10px;
  font-weight: 600;
  letter-spacing: 0.2px;
  box-shadow: var(--shadow);
  transition: transform 120ms ease, background 120ms ease, border-color 120ms ease;
}

.button:hover:not(:disabled) {
  transform: translateY(-1px);
  border-color: #2c3b6c;
}

.button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.button.primary {
  background: linear-gradient(180deg, var(--primary), var(--primary-600));
  border: none;
}

.messages-panel {
  background: linear-gradient(180deg, rgba(18, 26, 53, 0.7), rgba(18, 26, 53, 0.5));
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  overflow: hidden;
}

.messages-section {
  display: flex;
  flex-direction: column;
}

.messages-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-bottom: 1px solid var(--border);
  background: var(--panel-2);
}

.messages-header h2 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--muted);
}

.messages-count {
  background: rgba(91, 140, 255, 0.15);
  color: var(--text);
  padding: 4px 8px;
  border-radius: 999px;
  font-size: 12px;
  border: 1px solid var(--border);
}

.messages-list {
  height: calc(100vh - 220px);
  overflow-y: auto;
  padding: 16px;
  box-sizing: border-box;
  text-align: left;
}

.message-card {
  background: linear-gradient(180deg, rgba(12, 18, 36, 0.7), rgba(12, 18, 36, 0.4));
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 10px;
}

.message-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
  color: var(--muted);
}

.message-type {
  font-weight: 600;
  font-size: 12px;
}

.message-time {
  font-size: 12px;
}

.message-content {
  margin: 0;
  white-space: pre-wrap;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB;;aAEW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kFAAkF;EAClF,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kEAAkE;EAClE,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,+BAA+B;EAC/B,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,uFAAuF;AACzF;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,iFAAiF;EACjF,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uEAAuE;EACvE,YAAY;AACd;;AAEA;EACE,iFAAiF;EACjF,+BAA+B;EAC/B,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iFAAiF;EACjF,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,+GAA+G;EAC/G,eAAe;AACjB","sourcesContent":[":root {\n  --bg: #0b1020;\n  --panel: #121a35;\n  --panel-2: #0f1730;\n  --border: #223059;\n  --text: #e6e9f5;\n  --muted: #a9b3cf;\n  --primary: #5b8cff;\n  --primary-600: #4779ff;\n  --accent: #22d3ee;\n  --success: #10b981;\n  --warning: #f59e0b;\n  --danger: #ef4444;\n  --shadow: 0 10px 30px rgba(2, 6, 23, 0.5);\n  --radius: 12px;\n}\n\n.App {\n  min-height: 100vh;\n  background: radial-gradient(1200px 600px at 20% -10%, rgba(34, 211, 238, 0.12), transparent),\n    radial-gradient(1000px 500px at 120% 10%, rgba(91, 140, 255, 0.15), transparent),\n    var(--bg);\n  color: var(--text);\n}\n\n.app-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n}\n\n.topbar {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  background: linear-gradient(180deg, rgba(18, 26, 53, 0.85), rgba(18, 26, 53, 0.6));\n  backdrop-filter: blur(6px);\n  border-bottom: 1px solid var(--border);\n}\n\n.brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.brand-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--accent), var(--primary));\n  box-shadow: 0 0 12px rgba(34, 211, 238, 0.6);\n}\n\n.topbar h1 {\n  font-size: 18px;\n  margin: 0;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n}\n\n.status-badge {\n  padding: 6px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  border: 1px solid var(--border);\n  background: var(--panel);\n  color: var(--muted);\n}\n\n.status-badge.active {\n  color: #d1fae5;\n  border-color: rgba(16, 185, 129, 0.3);\n  background: linear-gradient(180deg, rgba(16, 185, 129, 0.15), rgba(16, 185, 129, 0.05));\n}\n\n.content {\n  max-width: 1100px;\n  width: 100%;\n  margin: 0 auto;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.controls {\n  display: flex;\n  gap: 12px;\n}\n\n.button {\n  appearance: none;\n  border: 1px solid var(--border);\n  background: linear-gradient(180deg, rgba(18, 26, 53, 0.9), rgba(18, 26, 53, 0.7));\n  color: var(--text);\n  padding: 10px 14px;\n  border-radius: 10px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  box-shadow: var(--shadow);\n  transition: transform 120ms ease, background 120ms ease, border-color 120ms ease;\n}\n\n.button:hover:not(:disabled) {\n  transform: translateY(-1px);\n  border-color: #2c3b6c;\n}\n\n.button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.button.primary {\n  background: linear-gradient(180deg, var(--primary), var(--primary-600));\n  border: none;\n}\n\n.messages-panel {\n  background: linear-gradient(180deg, rgba(18, 26, 53, 0.7), rgba(18, 26, 53, 0.5));\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow);\n  overflow: hidden;\n}\n\n.messages-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.messages-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--border);\n  background: var(--panel-2);\n}\n\n.messages-header h2 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--muted);\n}\n\n.messages-count {\n  background: rgba(91, 140, 255, 0.15);\n  color: var(--text);\n  padding: 4px 8px;\n  border-radius: 999px;\n  font-size: 12px;\n  border: 1px solid var(--border);\n}\n\n.messages-list {\n  height: calc(100vh - 220px);\n  overflow-y: auto;\n  padding: 16px;\n  box-sizing: border-box;\n  text-align: left;\n}\n\n.message-card {\n  background: linear-gradient(180deg, rgba(12, 18, 36, 0.7), rgba(12, 18, 36, 0.4));\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  padding: 12px;\n  margin-bottom: 10px;\n}\n\n.message-meta {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 6px;\n  color: var(--muted);\n}\n\n.message-type {\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.message-time {\n  font-size: 12px;\n}\n\n.message-content {\n  margin: 0;\n  white-space: pre-wrap;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
